import React from 'react'
import FatalErrorSvg from '../../../Assets/Fatal Error.svg'
import {
  Wrapper,
  ErrorImgWrapper,
  ErrorImg,
  ErrorMessage,
} from './styles'

const DEFAULT_MESSAGE =
  'Something went wrong. Please contact the ResiDesk Team.'

const ErrorMessageComponent = ({ message }) => (
  <Wrapper>
    <ErrorImgWrapper>
      <ErrorImg src={FatalErrorSvg} alt="" />
      <ErrorMessage>{message || DEFAULT_MESSAGE}</ErrorMessage>
    </ErrorImgWrapper>
  </Wrapper>
)
export default ErrorMessageComponent
